import { useMantineTheme } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Text } from '~/domains/design-system/Text';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import type { MyUserContest } from '~/domains/contest/domains/myContests/types/userContest';

import GuaranteedPlusBadge from '../../../../../design-system/badges/GuaranteedPlusBadge/GuaranteedPlusBadge';
import { useCountdown } from '../../hooks/useCountdown';

type GuaranteedPlusCountdownPillProps = {
  contest: Contest | MyUserContest;
};

function GuaranteedPlusCountdownPill({ contest }: GuaranteedPlusCountdownPillProps) {
  const theme = useMantineTheme();
  const additionalPayoutSettings = contest.additional_payout_settings;
  const { t } = useTranslation('contest');

  const { timeLeft, hasDeadlinePassed } = useCountdown(
    additionalPayoutSettings?.deadline ? new Date(additionalPayoutSettings.deadline) : new Date()
  );

  if (
    !additionalPayoutSettings?.enabled ||
    !additionalPayoutSettings?.deadline ||
    hasDeadlinePassed
  ) {
    return null;
  }

  return (
    <Text
      sx={{
        width: 'fit-content',
        borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 50,
        padding: /* eslint-disable-line local-rules/use-theme-tokens */ '4px 8px',
        ...theme.other.glass,
        color: theme.white,
        fontWeight: 600,
        fontSize: '10px',
        display: 'flex',
        alignItems: 'center',
        textTransform: 'uppercase',
      }}
    >
      <GuaranteedPlusBadge size="micro" style={{ marginRight: theme.other.spacing._4 }} />
      {t('common.guaranteedPlusCountdownPill.title', { timeLeft })}
    </Text>
  );
}

export default GuaranteedPlusCountdownPill;
